import { render, staticRenderFns } from "./le-upload-file-img.vue?vue&type=template&id=6ba2261a&scoped=true&"
import script from "./le-upload-file-img.vue?vue&type=script&lang=js&"
export * from "./le-upload-file-img.vue?vue&type=script&lang=js&"
import style0 from "./le-upload-file-img.vue?vue&type=style&index=0&id=6ba2261a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2261a",
  null
  
)

export default component.exports